import { Row } from '@cuemath/comps';
import React from 'react';
import { POCWrapper } from 'screens/student-details/styled-comps';
import { getFormattedDate } from 'utils';
import { CopyButton } from 'comps';
import { Separator, Text } from '@cuemath/web-comps';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const CustomRow = styled(Row)`
  margin-bottom: 12px;
`;
const LabelText = styled(Text)`
  min-width: 150px;
`;

const MakeUpClassesInfo = props => {
  const {
    class_start_datetime,
    is_urgent,
    lapse_date,
    state,
    student_classroom_id,
    student_course_id,
    student_leave_usage_id,
    teacher_id,
  } = props;

  return (
    <POCWrapper>
      <CustomRow alignItems="center">
        <LabelText variant="eyebrow2">Urgent</LabelText>
        <Text variant="body1Medium">{is_urgent ? 'Yes' : 'No'}</Text>
      </CustomRow>
      <CustomRow alignItems="center">
        <LabelText variant="eyebrow2">Class Start Time</LabelText>
        <Text variant="body1Medium">
          {getFormattedDate(class_start_datetime * 1000, 'DD MMM YY, hh:mm A')}
        </Text>
      </CustomRow>
      <CustomRow alignItems="center">
        <LabelText variant="eyebrow2">Lapse date</LabelText>
        <Text variant="body1Medium">
          {getFormattedDate(lapse_date * 1000, 'DD MMM YY, hh:mm A')}
        </Text>
      </CustomRow>
      <CustomRow alignItems="center">
        <LabelText variant="eyebrow2">State</LabelText>
        <Text variant="body1Medium">{state}</Text>
      </CustomRow>
      <CustomRow alignItems="center">
        <LabelText variant="eyebrow2">Student Classroom Id</LabelText>
      </CustomRow>
      <CopyButton
        copyMessage="Copy Student Classroom Id"
        text={student_classroom_id || 'N/A'}
      />
      <Separator height={12} />
      <CustomRow alignItems="center">
        <LabelText variant="eyebrow2">Student Course Id</LabelText>
      </CustomRow>
      <CopyButton
        copyMessage="Copy Student Course Id"
        text={student_course_id || 'N/A'}
      />
      <Separator height={12} />
      <CustomRow alignItems="center">
        <LabelText variant="eyebrow2">Student Leave Usage Id</LabelText>
      </CustomRow>
      <CopyButton
        copyMessage="Copy Student Leave Usage Id"
        text={student_leave_usage_id || 'N/A'}
      />
      <Separator height={12} />
      <CustomRow alignItems="center">
        <LabelText variant="eyebrow2">Teacher Id</LabelText>
      </CustomRow>
      <CopyButton copyMessage="Copy Teacher Id" text={teacher_id || 'N/A'} />
    </POCWrapper>
  );
};

MakeUpClassesInfo.propTypes = {
  class_start_datetime: PropTypes.number,
  is_urgent: PropTypes.bool,
  lapse_date: PropTypes.number,
  student_classroom_id: PropTypes.string,
  student_course_id: PropTypes.string,
  state: PropTypes.string,
  student_leave_usage_id: PropTypes.string,
  teacher_id: PropTypes.string,
};

export default MakeUpClassesInfo;
